export default __webpack_public_path__ + "static/media/logo.38b4dd64.png";